export default __webpack_public_path__ + "static/media/thumb-Nacic-Clock-5.6262e5c0.png";